<template>
  <div id="root">
    <div v-show="sho == false" class="t_logo">
      <a :href="keuri">
        <img :class="layers?'imgs':'img'" src="../assets/kefu.png" alt="" srcset="">
      </a>
    </div>

    <div v-if="mask_layers == true" class="mask_layers"></div>
    <div v-if="mask_layers == true" class="mask_layers_txt"><a href="">点击返回首页></a></div>
    <img v-if="mask_layers == true" :class="layers?'maskimg':'maskimgs'" src="../assets/mask.png" alt="" srcset="">

    <div v-show="sho == true" class="ramp-loader-container">
      <svg class="ramp-loader" viewBox="0 0 51 32" fill="none">
        <path
          d="M16.2232 18.8309L22.282 24.912C22.7953 25.4272 22.7948 26.2647 22.281 26.7792L17.651 31.4158C16.8619 32.1947 15.5719 32.1947 14.7828 31.4158L0.591812 17.4093C-0.197271 16.6305 -0.197271 15.3571 0.591812 14.5783L14.7828 0.584122C15.5719 -0.194707 16.8619 -0.194707 17.651 0.584122L22.281 5.22078C22.7948 5.73535 22.7953 6.57281 22.282 7.08795L16.2232 13.1691C14.645 14.7267 14.645 17.2733 16.2232 18.8309Z"
          fill="#ffffff"></path>
        <path
          d="M34.4433 18.8309L28.3845 24.912C27.8712 25.4272 27.8717 26.2647 28.3855 26.7792L33.0155 31.4158C33.8046 32.1947 35.0946 32.1947 35.8837 31.4158L50.0747 17.4093C50.8638 16.6305 50.8638 15.3571 50.0747 14.5783L35.8837 0.584122C35.0946 -0.194707 33.8046 -0.194707 33.0155 0.584122L28.3855 5.22078C27.8717 5.73535 27.8712 6.57281 28.3845 7.08795L34.4433 13.1691C36.0215 14.7267 36.0215 17.2733 34.4433 18.8309Z"
          fill="#ffffff"></path>
        <path
          d="M17.8128 17.157C17.1737 16.518 17.1737 15.482 17.8128 14.843L24.1765 8.47926C24.8155 7.84025 25.8515 7.84025 26.4905 8.47926L32.8542 14.843C33.4932 15.482 33.4932 16.518 32.8542 17.157L26.4905 23.5207C25.8515 24.1598 24.8155 24.1598 24.1765 23.5207L17.8128 17.157Z"
          fill="#ffffff"></path>
      </svg>
    </div>
    <div v-show="sho == false" class="style__hostedAppContainer--2-TAz">
      <div class="style__widgetContainer--1-mli">
        <main class="style__app--1-qXZ appDesktop style__appDesktop--2RdKU">
          <div class="style__app--1-qXZ-ad-left" v-show="advertisement == true && advertisementimg">
            <div><img class="style__app--1-qXZ-ad-img" @click="close()" style="" src="../assets/cha.png" alt=""
                srcset=""></div>
            <img class="style__app--1-qXZ-ad-left-img" style="" :src="advertisementimg" alt="" srcset="">
          </div>

          <div v-show="d==true" class="style__overviewContainer--3T5qH style__overviewShown--187jW">
            <div class="style__headerRow--1OfcR">
              <div class="style__hostInfo--1Z7ho"><img src="../assets/HQSH.svg" alt="Ramp Network logo"
                  class="style__hostImg--1GbG6"></div>
              <div class="style__headerNestedRow--30GK3">
                <div class="style__sellBuyToggle--2ZmUY style__disabled--2jPNF">
                  <div class="style__sell--2TIvN style__active--O86GY">Buy</div><span class="style__self--3-EoN"
                    role="tooltip">
                  </span>
                </div>
              </div>
            </div>
            <div class="">
              <div :class="isActive ? 'style__fiatBox--r2aUJ' : 'style__fiatBox--r2aUJerror'">
                <div class="style__container--9POtv">
                  <div>
                    <div class="style__header--5lal0">You pay</div><input class="style__amountInput--2NuMy" type="text"
                      v-on:input="oninput" placeholder="0.00" value="0.00" v-model="pay">
                  </div><button v-show="b == true" @click="godetail()" class="style__currencyButton--3ZnTY"><img
                      class="style__currencyLogo--3nYP8" :src="countryFirst.apiImage"><span
                      class="style__currencySymbol--1EeLB">{{countryFirst.currency}}</span><svg width="10" height="6"
                      viewBox="0 0 10 6" fill="none" class="style__chevronIcon--jbMbE">
                      <path opacity="0.6" fill-rule="evenodd" clip-rule="evenodd"
                        d="M.931 0a.8.8 0 00-.565 1.366l4.068 4.068a.8.8 0 001.132 0l4.068-4.068A.8.8 0 009.07 0H.93z"
                        fill="#898A97"></path>
                    </svg></button>

                  <button v-show="b == false" @click="godetail()" class="style__currencyButton--3ZnTY"><img
                      class="style__currencyLogo--3nYP8" :src="countryFirst.apiImage"><span
                      class="style__currencySymbol--1EeLB">{{countryFirst.currency}}</span><svg width="10" height="6"
                      viewBox="0 0 10 6" fill="none" class="style__chevronIcon--jbMbE">
                      <path opacity="0.6" fill-rule="evenodd" clip-rule="evenodd"
                        d="M.931 0a.8.8 0 00-.565 1.366l4.068 4.068a.8.8 0 001.132 0l4.068-4.068A.8.8 0 009.07 0H.93z"
                        fill="#898A97"></path>
                    </svg></button>

                </div>
                <div v-show="isActive == false" class="error-c">Please provide a valid order amount
                </div>
              </div>
              <div class="style__cryptoBox--33S9w">
                <div class="style__container--9POtv">
                  <div>
                    <div class="style__header--5lal0">You get</div><input class="style__amountInput--2NuMy" type="text"
                      inputmode="" placeholder="0.00" v-model="gain" value="">
                  </div><button v-show="e == true" @click="godetailbutton()" class="style__currencyButton--3ZnTY"><img
                      style="border-radius: 50%;" class="style__assetLogo--18mFq" :src="coinFirst.apiImage"><span
                      class="style__currencySymbol--1EeLB">{{coinFirst.coin_name}}</span><svg width="10" height="6"
                      viewBox="0 0 10 6" fill="none" class="style__chevronIcon--jbMbE">
                      <path opacity="0.6" fill-rule="evenodd" clip-rule="evenodd"
                        d="M.931 0a.8.8 0 00-.565 1.366l4.068 4.068a.8.8 0 001.132 0l4.068-4.068A.8.8 0 009.07 0H.93z"
                        fill="#898A97"></path>
                    </svg></button>
                  <button v-show="e == false" @click="godetailbutton()" class="style__currencyButton--3ZnTY"><img
                      style="width: 30px;height: 30px;border-radius: 50%;" class="style__assetLogo--18mFq"
                      :src="coinFirst.apiImage"><span
                      class="style__currencySymbol--1EeLB">{{coinFirst.coin_name}}</span><svg width="10" height="6"
                      viewBox="0 0 10 6" fill="none" class="style__chevronIcon--jbMbE">
                      <path opacity="0.6" fill-rule="evenodd" clip-rule="evenodd"
                        d="M.931 0a.8.8 0 00-.565 1.366l4.068 4.068a.8.8 0 001.132 0l4.068-4.068A.8.8 0 009.07 0H.93z"
                        fill="#898A97"></path>
                    </svg></button>
                </div>
                <div class="style__errorMessage--1ECu8"></div>
              </div>
            </div>

            <div class="style__feeBreakdownContainer--3NHkQ"><span class="style__exchangeRateInfo--3v2eK">1
                {{coinFirst.coin_name}} ≈
                {{result}}&nbsp;{{countryFirst.currency}}</span>
              <div class="style__feeInfoExtended--Y12zE">
                <div class="style__feeInfoExtendedAllContainer--2mPB2"><span
                    class="style__totalValue--3IMzE">{{pay}}&nbsp;{{countryFirst.currency}}</span>&nbsp;is
                  all you pay,
                  fees included
                </div>
              </div>
            </div>

            <div v-show="c == true" class="style__buttonRowContainer--2fPgA">
              <button v-if="device == 'pc'" @click="gostate()" style="margin-top: 100px;" class="style__btn_top">Proceed
                • total
                ${{pay}}<svg width="14" height="12" viewBox="0 0 14 12" fill="none" class="style__btnIcon--B225L"
                  aria-hidden="true">
                  <path
                    d="M8 9.586c0 .89 1.077 1.337 1.707.707l3.586-3.586a1 1 0 000-1.414L9.707 1.707C9.077 1.077 8 1.523 8 2.414v7.172z"
                    fill="#fff"></path>
                  <rect y="5" width="9" height="2" rx="1" fill="#fff"></rect>
                </svg></button>
              <button v-if="device == 'phone'" @click="gostate()" style="margin-top: 20%;"
                class="style__btn_top">Proceed • total
                ${{pay}}<svg width="14" height="12" viewBox="0 0 14 12" fill="none" class="style__btnIcon--B225L"
                  aria-hidden="true">
                  <path
                    d="M8 9.586c0 .89 1.077 1.337 1.707.707l3.586-3.586a1 1 0 000-1.414L9.707 1.707C9.077 1.077 8 1.523 8 2.414v7.172z"
                    fill="#fff"></path>
                  <rect y="5" width="9" height="2" rx="1" fill="#fff"></rect>
                </svg></button>
            </div>

            <div class="style__poweredByRamp--1-Vfl"><span class="style__poweredByRampText--3RS5A">Powered
                by <a class="style__link--SM_UB" href="" target="_blank" rel="noreferrer noopener">
                  <img width="52" height="12" src="../assets/HQSH-black.svg" alt="Ramp Network logo"
                    class="style__logoImage--173vr">
                </a>, an <a class="style__link--SM_UB" href="" target="_blank" rel="noreferrer noopener">official
                  cryptoasset business</a></span></div>
          </div>



          <div v-show="a == true"
            style="padding-top: 0px;display: flex;padding-left: 0;padding-right: 0;align-items: center;"
            class="style__overviewContainer--3T5qH style__overviewShown--187jWs">
            <div class="style__selectAssetCmpHeader--1z1Wo">
              <p style="height: 50px;font-size: 16px;">Select Country</p>
              <button style="display: flex;align-items: center;" class="style__closeButton--14qf6 "><svg
                  style="padding-right: 10px;width: 24px;height: 24px;" @click="goli()" viewBox="0 0 18 18" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M.705 2.296A1.125 1.125 0 012.295.705l15 15a1.125 1.125 0 01-1.59 1.59l-15-15z" fill="#CDCEE4">
                  </path>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M17.296 2.296A1.125 1.125 0 0015.705.705l-15 15a1.125 1.125 0 001.59 1.59l15-15z" fill="#CDCEE4">
                  </path>
                </svg></button>
            </div>
            <div style="padding-left: 15px;padding-right: 15px;"
              class="style__wrapper--1XKiV style__wrapper-search--2bnSe style__search--2jgRl">
              <label class="style__innerLabel--2bRGG">
                <input class="style__input--3UqEl style__input-search--1w8Qh" type="search" maxlength="128"
                  placeholder="Find your country">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" class="style__searchIcon--7KYcF">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8.176 13.745a5.575 5.575 0 01-5.569-5.57 5.576 5.576 0 015.569-5.568 5.576 5.576 0 015.569 5.569 5.575 5.575 0 01-5.57 5.569zM8.175.75a7.425 7.425 0 100 14.85 7.425 7.425 0 000-14.85z"
                    fill="currentColor"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M16.593 15.282a.928.928 0 01-1.313 1.312L12 13.314 13.31 12l3.282 3.282z" fill="currentColor">
                  </path>
                </svg>
              </label>
            </div>
            <div
              style="padding-left: 15px;padding-bottom: 10px;color: var(--tertiary);font-size: 13px;font-weight: 600;line-height: 20px;">
              Available now</div>
            <div class="scroll">
              <div @click="goxuan(item)" v-for="(item,index) in countryList" class="scroll-top">
                <div style="display: flex;align-items: center;">
                  <div style="display: flex;align-items: center;"><img
                      style="width: 30px;height: 30px;border-radius: 50%;" :src="item.apiImage" mode="" />
                  </div>
                  <div style="margin-left: 20px;color: var(--tertiary);font-size: 13px;font-weight: 700;">
                    {{item.country}}
                  </div>
                </div>
                <div style="color: var(--secondary);font-size: 13px;font-weight: 700;">{{item.currency}}
                </div>
              </div>
            </div>
          </div>


          <div v-show="a1 == true"
            style="padding-top: 0px;display: flex;padding-left: 0;padding-right: 0;align-items: center;"
            class="style__overviewContainer--3T5qH style__overviewShown--187jWs">
            <div class="style__selectAssetCmpHeader--1z1Wo">
              <p style="height: 50px;font-size: 16px;">Select Asset</p>
              <button style="display: flex;align-items: center;" class="style__closeButton--14qf6 "><svg
                  style="padding-right: 10px;width: 24px;height: 24px;" @click="golibuttom()" viewBox="0 0 18 18"
                  fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M.705 2.296A1.125 1.125 0 012.295.705l15 15a1.125 1.125 0 01-1.59 1.59l-15-15z" fill="#CDCEE4">
                  </path>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M17.296 2.296A1.125 1.125 0 0015.705.705l-15 15a1.125 1.125 0 001.59 1.59l15-15z" fill="#CDCEE4">
                  </path>
                </svg></button>
            </div>
            <div style="padding-left: 15px;padding-right: 15px;"
              class="style__wrapper--1XKiV style__wrapper-search--2bnSe style__search--2jgRl">
              <label class="style__innerLabel--2bRGG">
                <input class="style__input--3UqEl style__input-search--1w8Qh" type="search" maxlength="128"
                  placeholder="Find asset">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" class="style__searchIcon--7KYcF">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8.176 13.745a5.575 5.575 0 01-5.569-5.57 5.576 5.576 0 015.569-5.568 5.576 5.576 0 015.569 5.569 5.575 5.575 0 01-5.57 5.569zM8.175.75a7.425 7.425 0 100 14.85 7.425 7.425 0 000-14.85z"
                    fill="currentColor"></path>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M16.593 15.282a.928.928 0 01-1.313 1.312L12 13.314 13.31 12l3.282 3.282z" fill="currentColor">
                  </path>
                </svg>
              </label>
            </div>
            <div
              style="padding-left: 15px;padding-bottom: 10px;color: var(--tertiary);font-size: 13px;font-weight: 600;line-height: 20px;">
              Available now</div>
            <div class="scroll">
              <div @click="goxuanbuttom(item)" v-for="(item,index) in coinList" class="scroll-top">
                <div style="display: flex;align-items: center;">
                  <div style="display: flex;align-items: center;">
                    <img style="width: 30px;height: 30px;border-radius: 50%;" :src="item.apiImage" mode="" />
                  </div>
                  <div style="margin-left: 20px;color: var(--tertiary);font-size: 13px;font-weight: 700;">
                    {{item.coin_name}}
                  </div>
                </div>

              </div>
            </div>
          </div>



          <div v-show="state == true" class="phone_pc">
            <div class="style__content--3o3us">
              <div style="color: var(--greyscale-600);padding: 2px 0 2px 2px;">Please enter your email
                address：</div>
              <div class="style__wrapper--1XKiV undefined style__emailInput--3Ixe9"><label
                  class="style__innerLabel--2bRGG"><input v-model="email" class="style__input--3UqEl undefined"
                    type="email" maxlength="320" name="email" autocomplete="on" autocapitalize="off"
                    placeholder="Your email address" value=""></label>
              </div>
              <div style="color: var(--greyscale-600);padding: 2px 0 2px 2px;">Your Digital currency address：
              </div>
              <div class="style__wrapper--1XKiV undefined style__emailInput--3Ixe9"><label
                  class="style__innerLabel--2bRGG"><input v-model="name" class="style__input--3UqEl undefined"
                    type="name" maxlength="320" name="email" autocomplete="on" autocapitalize="off"
                    placeholder="Digital currency address" value=""></label>
              </div>
              <div style="color: var(--greyscale-600);padding: 2px 0 2px 2px;">Please select your bank card：</div>
              <el-select class="my-el-select style__innerLabel--2bRGG" v-model="value" filterable
                placeholder="Please select">
                <el-option v-for="item in options" :key="item.bank" :label="item.bank" :value="item.bank">
                </el-option>
              </el-select>
            </div>
            <div style="" class="style__buttonRowContainer--2fPgA"><button
                class="style__btn--3mWzZ style__btn-secondary-rtl--2KR9Z" @click="gotostate()">Back<svg width="14"
                  height="12" viewBox="0 0 14 12" fill="none" class="style__btnIcon--B225L" aria-hidden="true">
                  <path
                    d="M8 9.586c0 .89 1.077 1.337 1.707.707l3.586-3.586a1 1 0 000-1.414L9.707 1.707C9.077 1.077 8 1.523 8 2.414v7.172z"
                    fill="#fff"></path>
                  <rect y="5" width="9" height="2" rx="1" fill="#fff"></rect>
                </svg></button>
              <div class="style__btn--3mWzZ style__btn-primary--VyBF1_" @click="goho()">
                <div>
                  Proceed
                </div>
                <div style="display: flex;justify-content: flex-end;">
                  <img style="width: 20px;height: 20px;" src="../assets/you.png">
                </div>
              </div>
            </div>
          </div>
          <div class="ad_right" v-show="advertisement1 == true && advertisementimgs">
            <div><img class="ad_right-cha" @click="close1()" style=""
                src="../assets/cha.png" alt="" srcset=""></div>
            <img class="ad_right-img" style="" src="../assets/cha.png" alt="" srcset="">
          </div>
        </main>
      </div>
      <div class="style__footer--3fkOx">
        <div class="style__footerContents--2yitU">
          <div id="">
            <img width="138" height="30px" src="../assets/HQSH.svg" alt="Ramp Network logo"
              class="style__hostImg--1GbG6">
          </div>
          <div class="style__legalInfoBox--3ZLam"><span>HQSH Swaps Ltd is registered as a cryptoasset
              business by the UK Financial Conduct Authority for crypto activity. Ramp Swaps LLC is
              registered as a money services business registered by the U.S. Department of the
              Treasury's Financial Crimes Enforcement Network</span><span>More about us&nbsp;<a href=""
                class="style__legalLink--Bv2Cv">here</a></span></div>
        </div>
      </div>
    </div>
    <!-- <el-table v-loading="loading" style="width: 100%"></el-table> -->
  </div>
</template>

<script>
  export default {
    name: 'HelloWorld',
    data() {
      return {
        layers: '',
        mask_layers: false,
        advertisementimg: '',
        advertisementimgs: '',
        apiImage: '',
        advertisement: false,
        advertisement1: false,
        isActive: true,
        device: '',
        countryFirst: '',
        coinFirst: {},
        result: '',
        gain: '',
        pay: '',
        name: '',
        email: '',
        coin_id: '',
        options: [],
        value: '',
        countryList: [],
        coinList: [],
        sho: true,
        c: true,
        state: false,
        a: false,
        a1: false,
        b: true,
        d: true,
        e: true,
        keuri:''
      }
    },

    watch: {

      //付款
      pay: function(val) {
        let bili = ''
        switch (this.countryFirst.currency) { //想要判断的变量
          case 'USD': //状态一
            bili = this.coinFirst.usd_bili //状态一返回的结果
            break
          case 'EUR': //状态二
            bili = this.coinFirst.eur_bili //状态二返回的结果
            break
          case 'GBP': //状态三
            bili = this.coinFirst.gbp_bili //状态三返回的结果
            break
        }
        this.pay = val;
        this.gain = val / bili;

      },
      //获得
      gain: function(val) {

        let bili = ''
        switch (this.countryFirst.currency) { //想要判断的变量
          case 'USD': //状态一
            bili = this.coinFirst.usd_bili //状态一返回的结果
            break
          case 'EUR': //状态二
            bili = this.coinFirst.eur_bili //状态二返回的结果
            break
          case 'GBP': //状态三
            bili = this.coinFirst.gbp_bili //状态三返回的结果
            break
        }

        // this.pay = this.gain * bili;

      },
      'countryFirst.currency': function(val) {

        let bili = ''
        switch (val) { //想要判断的变量
          case 'USD': //状态一
            bili = this.coinFirst.usd_bili //状态一返回的结果
            break
          case 'EUR': //状态二
            bili = this.coinFirst.eur_bili //状态二返回的结果
            break
          case 'GBP': //状态三
            bili = this.coinFirst.gbp_bili //状态三返回的结果
            break
        }
        //this.pay = 1;
        this.gain = this.pay / bili;

      },

      'coinFirst.coin_name': function(val) {

        let bili = ''
        switch (this.countryFirst.currency) { //想要判断的变量
          case 'USD': //状态一
            bili = this.coinFirst.usd_bili //状态一返回的结果
            break
          case 'EUR': //状态二
            bili = this.coinFirst.eur_bili //状态二返回的结果
            break
          case 'GBP': //状态三
            bili = this.coinFirst.gbp_bili //状态三返回的结果
            break
        }

        if (isNaN(this.gain)) {
          this.gain = 1;
        }

        this.pay = this.gain * bili;
      }

    },
    created: function() {
      console.log(this.CustomConfig.baseUrl)
    },
    created() {
      var that = this;
      setTimeout(() => {
        that.sho = !that.sho
      }, 3000);

    },
    updated() {
      this.onresult()
    },
    mounted() {
      var that = this;
      that.isMobile();
      that.getCountry()
      that.getCoin();
      that.bank();
      that.adverimg()
      that.kefuurl()
    },
    methods: {
      kefuurl(){
        var that = this;
        that.$http.get("index/index/kefu").then((response) => {
          that.keuri = response.data.url
        })
      },
      bank() {
        var that = this;
        that.$http.get("index/index/bank").then((response) => {
          that.options = response.data
        })
      },
      adverimg() {
        var that = this;
        this.$http.get("index/index/ad").then((response) => {
          for (let i = 0; i < response.data.length; i++) {
            if (response.data[i].left_picture) {
              response.data[i]['apiImage'] = this.baseUrl + response.data[i].left_picture;
            }
            if (response.data[i].right_picture) {
              response.data[i]['apiImages'] = this.baseUrl + response.data[i].right_picture
            }
          }
          that.advertisementimg = response.data[0].apiImage;
          that.advertisementimgs = response.data[0].apiImages;
          console.log(that.advertisementimgs)
        })
      },
      close() {
        var that = this;
        that.advertisement = false
      },
      close1() {
        var that = this;
        that.advertisement1 = false
      },
      getCountry() {
        var that = this;
        that.$http.get("index/index/country").then((response) => {
          for (let i = 0; i < response.data.length; i++) {
            response.data[i]['apiImage'] = this.baseUrl + response.data[i].logo
          }
          that.countryList = response.data;

          that.countryFirst = response.data[0];
          console.log("that.countryFirst", that.countryFirst)
        })
      },
      getCoin() {
        var that = this;
        that.$http.get("index/index/coin").then((response) => {
          for (let i = 0; i < response.data.length; i++) {
            response.data[i]['apiImage'] = this.baseUrl + response.data[i].coin_logo
          }
          that.coinList = response.data;
          that.coinFirst = response.data[0];
        })
      },
      onresult() {
        let bili = ''
        switch (this.countryFirst.currency) { //想要判断的变量
          case 'USD': //状态一
            bili = this.coinFirst.usd_bili //状态一返回的结果
            break
          case 'EUR': //状态二
            bili = this.coinFirst.eur_bili //状态二返回的结果
            break
          case 'GBP': //状态三
            bili = this.coinFirst.gbp_bili //状态三返回的结果
            break
        }

        this.result = bili
      },
      oninput() {
        var that = this
        if (that.pay == '') {
          console.log('空')
          that.isActive = false
        } else {
          that.isActive = true
        }
      },
      gostate() {
        var that = this;
        if (that.pay == '' || that.gain == '' || that.gain == 0 || that.pay == 0) {
          alert("The input cannot be blank, please re-enter！");
          return false;
        } else {
          console.log(that.device)
          if (that.device == 'pc') {
            that.state = true;
            that.c = false;
          } else {
            that.state = true;
            that.c = false;
            that.d = false;
          }
        }
      },
      gotostate() {
        var that = this;
        if (that.device == 'pc') {
          that.state = false;
          that.c = true;
        } else {
          that.state = false;
          that.c = true;
          that.d = true
        }
      },
      godetail() {
        var that = this;
        that.a = true;
        that.d = false;
      },
      godetailbutton() {
        var that = this;

        that.a1 = true;
        that.d = false;
      },
      goli() {
        var that = this;
        that.a = false;
        that.d = true;
      },
      golibuttom() {
        var that = this;
        that.a1 = false;
        that.d = true;
      },
      goxuan(e) {
        var that = this;
        that.b = false;
        that.a = false;
        that.d = true;
        that.countryFirst = e;

      },
      goxuanbuttom(e) {
        var that = this;
        that.coinFirst = e;
        that.a1 = false;
        that.d = true;
        that.e = false;
      },
      goho() {
        var that = this
        var emails = that.email;
        var names = that.name;
        var card = that.value;
        let emailReg = /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/;
        if (!emailReg.test(emails)) {
          alert("The mailbox input is illegal, please re-enter！");
          return false;
        }
        if (names == '') {
          alert("The input cannot be blank, please re-enter！");
          return false;
        }
        console.log(card)
        if (card == '') {
          alert("The input cannot be blank, please re-enter！");
          return false;
        } else {
          var data = {
            pay_amount: that.pay,
            num: that.gain,
            coin_id: that.coinFirst.id,
            email: emails,
            currency_address: names,
            bank: card,
            country_id: that.countryFirst.id
          }
          that.$http({ //调用接口
            method: 'POST',
            data: data,
            url: this.baseUrl + 'index/index/submit', //this指data
            headers: {
              'Content-Type': 'application/json'
            }
          }).then(function(response) { //接口返回数据
            if (response.data.code == 1) {
              that.mask_layers = true
            } else {
              that.$notify({
                title: '警告',
                message: '提交失败，请重新提交',
                type: 'warning'
              });
            }
          }, function(error) {

          })

        }
      },
      isMobile() {
        var that = this;
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        if (flag) {
          that.device = "phone";
          that.layers = false
        } else {
          that.device = "pc";
          that.advertisement = true;
          that.advertisement1 = true;
          that.layers = true
        }
      }
    }
  }
</script>

<style scoped>
  .ad_right{
    margin-left: 100px;
    background: white;
    position:relative;
  }
  .ad_right .ad_right-cha{
    width: 20px;
    height: 20px;
    position: absolute;
    right: 0;
  }
  .ad_right .ad_right-img{
    width: 200px;
    height: 590px;
  }
  .style__app--1-qXZ-ad-left {
    margin-right: 100px;
    background: white;
    position: relative;
  }

  .style__app--1-qXZ-ad-left .style__app--1-qXZ-ad-img {
    width: 20px;
    height: 20px;
    position: absolute;
    right: 0;
  }

  .style__app--1-qXZ-ad-left .style__app--1-qXZ-ad-left-img {
    width: 200px;
    height: 590px;
  }

  .mask_layers_txt {
    font-size: 22px;
    font-weight: 900;
    position: absolute;
    left: 10px;
    z-index: 999;
  }

  .mask_layers_txt a {
    text-decoration: none;
    color: #fff;
  }

  .t_logo {
    position: absolute;
    bottom: 50px;
    right: 10px;
    z-index: 999;
  }

  .t_logo .img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }

  .t_logo .imgs {
    width: 60px;
    height: 60px;
    border-radius: 50%;
  }

  .mask_layers {
    width: 100%;
    height: 100%;
    z-index: 1;
    position: fixed;
    opacity: 0.7;
    background-color: #000;
  }

  .maskimg {
    position: absolute;
    bottom: 70px;
    right: 80px;
    z-index: 99;
    width: 450px;
    height: 120px;
  }

  .maskimgs {
    position: absolute;
    bottom: 70px;
    right: 60px;
    z-index: 99;
    width: 80%;
    height: 80px;
  }

  .error-c {
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid rgba(162, 169, 188, .1);
    color: var(--error);
    font-size: 13px;
    font-weight: 400;
    height: 34px;
  }

  .style__fiatBox--r2aUJerror {
    background: var(--white);
    border: 1px solid red;
    border-radius: 4px;
    cursor: pointer;
    width: 100%;
    margin: 16px 0
  }

  .style__fiatBox--r2aUJerror .style__container--9POtv {
    align-items: center;
    display: flex;
    padding: 15px 16px
  }

  .style__fiatBox--r2aUJerror .style__header--5lal0 {
    color: var(--secondary);
    font-size: 10px;
    font-weight: 700;
    line-height: 13px;
    text-transform: uppercase
  }

  .phone_pc {
    height: 590px;
    background-color: white;
    width: 516px;
    margin-left: 3px;
    border-radius: 8px;
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  @media screen and (max-width:500px) {
    .phone_pc {
      margin-top: 20px;
      height: 550px;
      background-color: white;
      width: 90vw;
      margin-left: 3px;
      border-radius: 8px;
      padding: 24px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }

  .style__btn-primary--VyBF1_ {
    background-color: var(--primary);
    display: flex;
    justify-content: space-between;
  }

  .my-el-select /deep/ .el-input .el-input__inner {
    border-color: #DCDFE6 !important;
    height: 48px !important;
    color: rgb(34, 39, 47) !important;
  }

  .my-el-select /deep/ .el-input .el-input__inner:hover {
    border-color: #22272f !important;
    color: #000000 !important;
  }

  .my-el-select /deep/ .el-input .el-input__inner::placeholder {
    color: var(--greyscale-600);
    font-family: Mulish;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    opacity: 1;
  }

  .my-el-select /deep/ .el-input .el-input__inner:hover::placeholder {
    color: var(--tertiary)
  }

  .scroll {
    border: 1pxsolid#000;
    padding-left: 15px;
    padding-right: 15px;
    overflow: auto;
    margin-bottom: 15px;
    /* height: 4px; */
  }

  .scroll-top {
    display: flex;
    padding: 0 10px 0 10px;
    justify-content: space-between;
    align-items: center;
    height: 40px;
    width: 100%;
    border: 1px solid rgba(var(--border-light-rgb), .2);
    margin-bottom: 10px;
  }

  .scroll-top:hover {
    border: 1px solid #13CE66;
  }

  .scroll::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 6px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
  }

  /*正常情况下滑块的样式*/

  .scroll::-webkit-scrollbar-thumb {
    /* background-color: #13CE66; */
    border-radius: 10px;
    height: 4px;
    background-color: #13CE66;
    /* -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, .1); */
  }

  /*鼠标悬浮在该类指向的控件上时滑块的样式*/

  /* .scroll:hover::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, .2);
    border-radius: 10px;
    -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, .1);
  } */

  /*鼠标悬浮在滑块上时滑块的样式*/
  /* .scroll::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, .4);
    -webkit-box-shadow: inset 1px 1px 0 rgba(0, 0, 0, .1);
  } */

  /*正常时候的主干部分*/
  .scroll::-webkit-scrollbar-track {
    height: 1px;
  }

  /*鼠标悬浮在滚动条上的主干部分*/
  /* .scroll::-webkit-scrollbar-track:hover {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .4);
    background-color: rgba(0, 0, 0, .01);
  } */



  .ramp-loader-container {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(104.98deg, #21bf73 1.87%, #0a6e5c 99.59%);
    position: absolute;
    top: 0;
    left: 0;
  }

  .ramp-loader {
    width: 100px;
    height: auto;
    transform-origin: center;
    animation: logoRotate 4s linear infinite;
  }

  .ramp-loader path:nth-child(3) {
    transform-origin: center;
    position: relative;
  }

  .ramp-loader path:nth-child(1) {
    transform-origin: center;
    position: relative;
    animation: leftArrowAnimation 4s linear infinite;
    transform: scale(0.4) translateX(6px);
  }

  .ramp-loader path:nth-child(2) {
    transform-origin: center;
    position: relative;
    animation: rightArrowAnimation 4s linear infinite;
    transform: scale(0.4) translateX(-6px);
  }

  @keyframes logoRotate {
    10% {
      transform: rotate(180deg);
    }

    30% {
      transform: rotate(360deg);
    }

    70% {
      transform: rotate(360deg);
    }

    90% {
      transform: rotate(520deg);
    }

    100% {
      transform: rotate(720deg);
    }
  }

  @keyframes leftArrowAnimation {

    0%,
    10% {
      transform: scale(0.4) translateX(6px);
    }

    30%,
    70% {
      transform: scale(1) translateX(0);
    }

    90% {
      transform: scale(0.4) translateX(6px);
    }
  }

  @keyframes rightArrowAnimation {

    0%,
    10% {
      transform: scale(0.4) translateX(-6px);
    }

    30%,
    70% {
      transform: scale(1) translateX(0);
    }

    90% {
      transform: scale(0.4) translateX(-6px);
    }
  }

  .style__btn_top {
    --button-padding: 16px;
    align-items: center;
    border: 0;
    border-radius: 4px;
    color: var(--white);
    cursor: pointer;
    display: flex;
    font-size: 14px;
    font-weight: 600;
    justify-content: space-between;
    line-height: 1;
    max-height: 48px;
    outline: 0;
    padding: var(--button-padding);
    position: relative;
    text-align: center;
    text-decoration: none;
    /* transition: all .18s ease-in; */
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    background-color: rgb(33, 191, 115);
    /* background-color: rgb(171, 231, 202); */
    border: 2px solid transparent;
    font-weight: 700;
    width: 300px;
    margin: 0 auto;
    letter-spacing: 2px;
    text-transform: uppercase
  }

  .style__selectAssetCmpHeader--1z1Wo {
    height: 50px;
    padding-left: 15px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid var(--grey-light);
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue